export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_01.9f9d35c0.jpg";